<template>
    <div class="showModal custom-modal dueModal follow-modal">
		<div @click.stop="">
		    <div class="secondatyBG follow-modal-box p-4 ">
                <div class="follow-modal-header d-flex align-items-center justify-content-between mb-4">
                    <h3 class="f-20">
                        <span v-if="!(confirmDelete || isSuccess)">{{alreadyFollowed?'Update':''}} Follow <span>{{ followName }}</span></span>
                    </h3>
                    <a class="text-center" href="#" @click.prevent="$emit('close')">
                        <img src="../../../../static/website/images/x-circle.svg" alt="">
                    </a>
                </div>
                <div v-if="isSuccess" class="isSuccess">
                    <div class="px-5 pt-0 pb-5">
                        <div class="mt-3 text-center px-4">
                            <img src="../../../../static/website/images/success-msg.svg" alt="">
                            <h3 class="f-20 mt-4">{{reponse_message}} <span class="linkColor">{{ followName }}</span></h3>
                            <!-- <p class="f-14 my-3">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p> -->
                            <div class="d-flex justify-content-center gx-15 mt-4 b-5" v-if="$route.name == 'leaders'">
                                <a href="#" class="btn whiteBG justify-content-center w-100 d-block" @click.prevent="$emit('close')">{{$t('follow_more')}}</a>
                                <a href="#" class="btn linkBG justify-content-center w-100 d-block" @click.prevent="$emit('backToDashboard')">{{$t('go_to_dashboard')}}</a>
                            </div>
                            <div class="d-flex justify-content-center gx-15 mt-4 b-5" v-else>
                                <router-link to="/leaders" class="btn whiteBG justify-content-center w-100 d-block">{{$t('follow_more')}}</router-link>
                                <router-link to="/leaders?tab=dashboard" class="btn linkBG justify-content-center w-100 d-block">{{$t('go_to_dashboard')}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <form v-else-if="confirmDelete">
                    <app-loader v-if="pageLoader"/>
                    <div class="">
                        <div class="invest-amt label d-flex justify-content-between align-items-center my-2">
                            <h3 class="f-20">{{$t('are_you_sure_stop_coping')}}</h3>
                        </div>
                        <div class="mt-3 d-flex justify-content-end space-between">
                            <a href="#" class="btn redBG justify-content-center w-100 d-block mr-2" @click.prevent="cancleTrade()">{{$t('yes')}}</a>
                            <a href="#" class="btn linkBG justify-content-center w-100 d-block" @click.prevent="confirmDelete = false">{{$t('no')}}</a>
                        </div>
                    </div>
                </form>
                <form v-else>
                    <app-loader v-if="pageLoader"/>
                    <!-- <select class="wt-select radius-5 w-100 bg-transparent" name="" id="" v-model="zulu_broker_account_id" @change="setAmount()" v-if="!alreadyFollowed">
                        <option value="" disabled>Select Account ID</option>
                        <optgroup v-for="list,acc_type in accountList" :label="acc_type+' Account'" class="text-red">
                            <option v-for="item in list[0].values" :value="item.zulu_broker_account_id">{{item.account_id}}</option>
                        </optgroup>
                    </select>
                    <span class="text-danger-error text-danger" v-if="showIdError && !zulu_broker_account_id && !alreadyFollowed">Please Select Account ID.</span> -->
                    <div class="form-group">
                        <div class="">
                            <input type="text" class="form-control bg-transparent f-16" :value="(get_user.username || '').split('$$')[1] || '-'" disabled>
                        </div>
                    </div>
                    <div class="">
                        <div class="invest-amt label d-flex justify-content-between align-items-center my-2">
                            <label class="f-16">{{alreadyFollowed?'Update ':''}}{{$t('invested_amount')}}</label>
                            <!-- <span class="linkBG d-flex justify-content-center align-items-center radius-4 ">&dollar;</span> -->
                        </div>
                        <div class="form-group">
                            <div class="input-inc-text position-relative">
                                <input type="number" class="form-control bg-transparent f-16" id=""placeholder="Enter amount" v-model="capitalProtectionAmount" min="0" :max="availableCapitals">                            
                                <span class="input-inc-text-box f-16 radius-4" for="">
                                    <a href="javascript:void(0)" @click="capitalProtectionAmount = availableCapitals">{{$t('max')}}</a>
                                </span>
                            </div>
                            <span class="text-danger-error text-danger" v-if="showAmountError && !Number(availableCapitals || 0)">{{$t('insufficient_funds')}}</span>
                            <span class="text-danger-error text-danger" v-else-if="showAmountError && !Number(capitalProtectionAmount || 0)">{{$t('enter_valid_amount')}}</span>
                            <span class="text-danger-error text-danger" v-else-if="showAmountError && Number(capitalProtectionAmount || 0) > availableCapitals">{{$t('maximum_amount_allowed')}} {{availableCapitals}}.</span>
                            <span id="emailHelp" class="form-text ">{{$t('available_capital')}}: <b>{{availableCapitals}}</b></span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" v-if="!alreadyFollowed">
                            <p class="f-16">{{$t('copy_open_trades')}}</p>
                            <div class="wt-toggle-btn">
                                <input type="checkbox" id="switch" v-model="openTrades"/><label for="switch">{{$t('toggle')}}</label>
                            </div>
                        </div>
                        <div class="mt-3 d-flex justify-content-end space-between">
                            <a href="#" class="btn redBG justify-content-center w-100 d-block mr-2" @click.prevent="confirmDelete = true" v-if="alreadyFollowed">{{$t('stop_following')}}</a>
                            <a href="#" class="btn linkBG justify-content-center w-100 d-block" @click.prevent="submitFollow()">{{alreadyFollowed?'Update Strategy':'Follow Strategy'}}</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { commonAllmixins } from "@/plugins/commonAll";
    export default{
        mixins: [commonAllmixins],
        emits:['close'],
        props:['followId','followName'],
        data(){
            return{
                pageLoader: false,

                zulu_broker_account_id : '',
                capitalProtectionAmount : '',
                openTrades : true,
                showIdError : false,
                showAmountError : false,
                confirmDelete : false,

                alreadyFollowed : false,
                isSuccess : false,
                reponse_message: 'You have successfully follow the ',
                accountList : {
                    "records" : [
                        {
                            "id": 466,
                            "account_id": "T2986",
                            "currency": "USD",
                            "platform": "ACT",
                            "act_account_id": "1396",
                            "demo_live": "live",
                            "account_type": "ECN",
                            "leverage": "100",
                            "zulu_broker_account_id": "2334279",
                            "zulu_account_id": "2668422"
                        },
                    ]
                }
            }
        },
        computed:{
            availableCapitals(){
                return (this.followersSetting.availableCapitals || {})[this.zulu_broker_account_id] || (this.alreadyFollowed || {}).availableCapital || 0
            }
        },
        methods:{
            getResponse(type){
                if(type == 'post'){
                    this.reponse_message = 'You are now Following '; //this.multiply9(this.followId);
                }else if(type == 'put'){
                    this.reponse_message = 'Strategy Updated';
                }else{
                    this.reponse_message = 'You have stopped Following '; //this.multiply9(this.followId);
                }
                this.isSuccess = true;
                this._runGetFollowersSetting({ globalParams: {}, localParams: { parameter: this } });
            },
            setAmount(){
                let amt = Number((parseFloat((this.availableCapitals*40)/100)).toPrecision(1));
                amt = amt > 0 ? amt :0;
                if(!amt){
                    this.showAmountError = true;
                }
                this.capitalProtectionAmount = amt ;
            },
            cancleTrade(){
                let zulu_account_id = this.alreadyFollowed.zuluAccountId
                let postApi = `${this.followId}?targetZuluAccountId=${zulu_account_id}&closeAllTrades=${this.openTrades}`
                this._runFollowTrade({ globalParams: {}, localParams: { parameter: this, postApi , isDelete : true } });
            },
            submitFollow(){
                this.showAmountError = false;
                
                let isUpdate = this.alreadyFollowed?true:false
                let account = this.userCopytradingDetails.zulu || {};
                /*this.showIdError = false;
                let account = this.accountList.records.find(v=>v.zulu_broker_account_id == this.zulu_broker_account_id) || {}
                if(!this.zulu_broker_account_id && !isUpdate){
                    this.showIdError = true;
                    return;
                }*/

                // console.log('zulu_account_id===========>',this.userCopytradingDetails.zulu.zulu_account_id)
                // console.log('zulu_broker_account_id===========>',this.userCopytradingDetails.zulu.zulu_broker_account_id)

                let zulu_account_id = isUpdate?this.alreadyFollowed.zuluAccountId:account.zulu_account_id

                if(!Number(this.capitalProtectionAmount || 0) || Number(this.capitalProtectionAmount || 0) > this.availableCapitals || !this.availableCapitals){
                    this.showAmountError = true;
                    return;
                }
                let data = {
                    "account_id": account.account_id || '',
                    "capitalProtectionAmount": this.capitalProtectionAmount,
                    "capitalProtectionModeId": 1,
                    "providerId": this.followId,
                    "stopOnProfit": 0,
                    "openTrades": this.openTrades
                }
                let postApi = `?targetZuluAccountId=${zulu_account_id}&openTrades=${this.openTrades}`
                this._runFollowTrade({ globalParams: data, localParams: { parameter: this, postApi , isUpdate } });
            },
            checkFollow(){
                let account = this.followersSetting.providers.find(v=>v.providerId == this.followId && v.zuluAccountId == this.userCopytradingDetails.zulu.zulu_account_id)
                if(account){
                    this.alreadyFollowed = account;
                    this.capitalProtectionAmount = account.capitalProtectionAmount;
                }else{
                    this.setAmount();
                }
            }
        },
        created(){
            this.zulu_broker_account_id = this.userCopytradingDetails.zulu.zulu_broker_account_id;
            this._runGetFollowersSetting({ globalParams: {}, localParams: { parameter: this, checkValue : true } });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/follow.vue